import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import alerta from './modules/alerta';

const api = Axios.create({
  baseURL: process.env.VUE_APP_API,
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    api,
    comunasURL: `${process.env.VUE_APP_API}utils/comunas`,
    barriosURL: `${process.env.VUE_APP_API}utils/barrios`,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    alerta,
  },
});
